import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[580px] md:h-[720px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20celebration%20background%20with%20flowing%20coral%20orange%20and%20golden%20gradient%20shapes%2C%20confetti%20particles%2C%20soft%20bokeh%20lights%2C%20festive%20energetic%20mood%2C%20artistic%20non%20realistic%20illustration&width=1800&height=1000&seq=hero-baogua-01&orientation=landscape"
        alt="爆瓜福利活动与抽奖氛围抽象插画"
        title="爆瓜福利 - 吃瓜娱乐福利站"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-8">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs md:text-sm backdrop-blur-sm">
          <i className="ri-fire-line text-accent-400"></i>
          本周新增 12 个福利活动
        </span>

        <h1 className="mt-6 text-4xl md:text-6xl text-white leading-tight font-heading">
          爆瓜福利
        </h1>
        <p className="mt-3 text-xl md:text-3xl text-accent-300 font-heading">吃瓜不吃亏，福利轻松领</p>

        <p className="mt-5 max-w-2xl text-sm md:text-base text-white/85 leading-relaxed">
          把散落在各个角落的福利活动、抽奖玩法与任务奖励规则讲清楚，三分钟看懂怎么参与、怎么领奖、怎么拿到专属奖励。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/activities"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-gift-line"></i>
            浏览福利活动
          </Link>
          <Link
            to="/rules"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-background-50/10 border border-background-50/40 text-background-50 text-base font-medium whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            查看玩法规则
          </Link>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs md:text-sm text-white/80">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line text-accent-400"></i>
            活动全程免费参与
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-eye-line text-accent-400"></i>
            抽奖概率公开可查
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-timer-flash-line text-accent-400"></i>
            奖励按时发放
          </span>
        </div>
      </div>
    </section>
  );
}